// @ts-nocheck
import { useEffect, useCallback, useState } from 'react';
import { format, parseISO } from 'date-fns';

import {
    PageHeader,
    TabContent
} from "../../styles/components";

import {
    Container,
    Content,
    Text,
    Title,
    ItemHeader,
    ItemBody,
    WhiteBox,
    Link,
    Info,
    IconInfo,
    TooltipInfo,
    CobrancaLista
} from "./styles";

import InsertDriveFileOutlinedIcon from '@material-ui/icons/InsertDriveFileOutlined';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import CalendarTodayOutlinedIcon from '@material-ui/icons/CalendarTodayOutlined';
import AttachMoneyOutlinedIcon from '@material-ui/icons/AttachMoneyOutlined';
import CreditCardOutlinedIcon from '@material-ui/icons/CreditCardOutlined';
import IconCashback from '../../assets/icons/cashback.png';
import Sad from '../../assets/icons/sad.png';

import Header from "../../components/Header";

import { useAuth } from '../../hooks/auth';
import api from "../../services/api";

// Cashback oculto na Central do Cliente a pedido do fundador (29/09/2026).
// Pra voltar a exibir, trocar para true.
const MOSTRAR_CASHBACK = false;

// Cobranças geradas no Asaas na assinatura do contrato (boleto, cartão, PIX
// recorrente). Transferência e dinheiro não aparecem aqui: não têm link.
function Cobrancas({ charges }) {
    if (!charges || charges.length === 0) {
        return <p className="sem-cobranca">Nenhum pagamento online neste pedido.</p>;
    }
    return (
        <CobrancaLista>
            {charges.map((charge, i) => (
                <li key={i} className={charge.paid ? "paga" : ""}>
                    <span>
                        <strong>{charge.value}</strong>
                        {" · "}{charge.method}
                        {charge.installment ? ` ${charge.installment}` : ""}
                        {" · vence "}{format(parseISO(charge.due_date), "dd/MM/yyyy")}
                    </span>
                    {charge.paid ? (
                        <em>Pago</em>
                    ) : (
                        <a href={charge.url} target="_blank" rel="noopener noreferrer">Pagar</a>
                    )}
                </li>
            ))}
        </CobrancaLista>
    );
}

export function Pagamentos() {
    const [payments, setPayments] = useState([]);
    const [tooltip, setTooltip] = useState(false);

    const { user } = useAuth();

    function handleTooltip(item, toggle) {
        setTooltip({ [item]: toggle });
    }

    useEffect(() => {
        api
            .get('central/payments')
            .then(response => {
                setPayments(response.data);
            });
    }, []);

    return (
        <>
            <Container>
                <Header />
                <PageHeader>
                    <Content>
                        <Text>
                            <Title>Meus Pagamentos</Title>
                        </Text>
                    </Content>
                </PageHeader>
                <h3>Veja detalhes de pagamento de cada pedido</h3>
                <TabContent>
                    <table>
                        <thead>
                            <tr>
                                <th>
                                    <ItemHeader>
                                        <InsertDriveFileOutlinedIcon />
                                        <p>Pedidos</p>
                                    </ItemHeader>
                                </th>
                                <th>
                                    <ItemHeader>
                                        <CalendarTodayOutlinedIcon />
                                        <p>Data da venda</p>
                                    </ItemHeader>
                                </th>
                                <th>
                                    <ItemHeader>
                                        <AttachMoneyOutlinedIcon />
                                        <p>Valor do Item</p>
                                    </ItemHeader>
                                </th>
                                {MOSTRAR_CASHBACK && (
                                <th>
                                    <ItemHeader>
                                        <img src={IconCashback} alt="Cashback"/>
                                        <p>Cashback</p>
                                    </ItemHeader>
                                </th>
                                )}
                                <th>
                                    <ItemHeader>
                                        <CreditCardOutlinedIcon />
                                        <p>Pagamentos</p>
                                    </ItemHeader>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <span />
                            { payments && payments.map((item, index) => (
                                <tr key={index}>
                                    <td>
                                        <p>
                                            {
                                                (item?.family_plan === "Nenhum" || !item?.family_plan) ?
                                                "Plano de Cidadania Portuguesa" :
                                                item?.family_plan
                                            }
                                        </p>
                                        <Info onClick={() => !handleTooltip(`indice`, index === tooltip.indice ? false : index)}>
                                            <p>Detalhes</p>
                                            <TooltipInfo active={tooltip.indice === index}>
                                                {item?.products.map((product, index) => (
                                                    <p key={index}>&bull; {product?.qty} {product.name}</p>
                                                ))}
                                            </TooltipInfo>
                                        </Info>
                                    </td>
                                    <td>
                                        <p><strong>{ format(parseISO(item?.created_at), "dd/MM/yyyy") }</strong></p>
                                        <p className="hour">às { format(parseISO(item?.created_at), "HH:mm") }</p>
                                    </td>
                                    <td>
                                        <p><strong>{ item?.total }</strong></p>
                                    </td>
                                    {MOSTRAR_CASHBACK && (
                                    <td>
                                        { (item?.cash_back_value && item.hasCashBack) ? (
                                            <>
                                                {item?.redeem_cash_back ? (
                                                    <>
                                                        <p>
                                                            <strong>R$ { (item?.cash_back_value / 100).toLocaleString('pt-BR',
                                                                { style: 'currency', currency: 'BRL' }) }
                                                            </strong>
                                                        </p>
                                                        <Link disabled>
                                                            Cashback resgatado
                                                        </Link>
                                                    </>
                                                ) : (
                                                    <>
                                                        <p>
                                                            <strong>{ (item?.cash_back_value / 100).toLocaleString('pt-BR',
                                                                { style: 'currency', currency: 'BRL' }) }
                                                            </strong>
                                                        </p>
                                                        {/* <Link target="_blank" href={`https://form.typeform.com/to/BX1MEglj#email=${item?.email}&idpipe=${item?.pt}`}>
                                                            Resgatar cashback
                                                        </Link> */}
                                                    </>
                                                )}
                                            </>
                                        ) :
                                            <ItemBody>
                                                <img src={Sad} alt="Sad"/>
                                                <p>Cashback indisponível</p>
                                            </ItemBody>
                                        }
                                    </td>
                                    )}
                                    <td>
                                        <Cobrancas charges={item?.charges} />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    { payments && payments.map((item, index) => (
                        <WhiteBox key={index}>
                            <p className="title">{ item?.family_plan }</p>
                            <ItemHeader>
                                <CalendarTodayOutlinedIcon />
                                <p>Data da venda</p>
                            </ItemHeader>
                            <p>
                                <strong>{ format(parseISO(item?.created_at), "dd/MM/yyyy") } </strong>
                                às { format(parseISO(item?.created_at), "HH:mm") }
                            </p>
                            <hr />
                            <ItemHeader>
                                <AttachMoneyOutlinedIcon />
                                <p>Valor do Item</p>
                            </ItemHeader>
                            <p><strong>{ item?.total }</strong></p>
                            {MOSTRAR_CASHBACK && (
                            <>
                            <hr />
                            <ItemHeader>
                                <img src={IconCashback} alt="Cashback"/>
                                <p>Cashback</p>
                            </ItemHeader>
                            { item?.cash_back_value ? (
                                <>
                                    {item?.redeem_cash_back === 1 ? (
                                        <>
                                            <p>
                                                <strong>{ (item?.cash_back_value / 100).toLocaleString('pt-BR',
                                                    { style: 'currency', currency: 'BRL' }) }
                                                </strong>
                                            </p>
                                            <Link disabled>
                                                Cashback resgatado
                                            </Link>
                                        </>
                                    ): (
                                        <>
                                            <p>
                                                <strong>{ (item?.cash_back_value / 100).toLocaleString('pt-BR',
                                                    { style: 'currency', currency: 'BRL' }) }
                                                </strong>
                                            </p>
                                            <Link target="_blank" href={`https://form.typeform.com/to/BX1MEglj#email=${item?.email}&idpipe=${item?.pt}`}>
                                                Resgatar cashback
                                            </Link>
                                        </>
                                    )}
                                </>
                            ) :
                                <ItemBody>
                                    <img src={Sad} alt="Sad"/>
                                    <p>Cashback indisponível</p>
                                </ItemBody>
                            }
                            </>
                            )}
                            <hr />
                            <ItemHeader>
                                <CreditCardOutlinedIcon />
                                <p>Pagamentos</p>
                            </ItemHeader>
                            <Cobrancas charges={item?.charges} />
                        </WhiteBox>
                    ))}
                </TabContent>
            </Container>
        </>
    );
}
